// @ts-nocheck
document.addEventListener("alpine:init", () => {
  Alpine.data("productInfo", (sectionId) => ({
    sectionId,
    mainProduct: {},
    selectedSellingPlanId: null,
    selectedVariantId: null,
    form: null,
    sellingPlanInput: null,
    variantIdChangedUnsubscriber: undefined,

    /**
     * Initialize the product card component
     */
    init() {
      this.parseProductJson();

      if (!this.mainProduct) {
        console.error("mainProduct is missing");
        return;
      }

      this.addEventListeners();
    },

    addEventListeners() {},

    /**
     * Initialize the new product
     * @param {Object} product - The new product
     */
    initNewProduct(product) {
      this.mainProduct = product;

      this.init();
    },

    /**
     * Parse the product JSON
     */
    parseProductJson() {
      const productData = JSON.parse(this.$refs.productDataJson.textContent);

      this.mainProduct = productData;
    },

    /**
     * Load the product
     * @param {string} productHandle - The product handle
     * @param {string} preselectedVariantId - The preselected variant ID
     */
    loadProduct(productHandle, preselectedVariantId = "") {
      const isProductPage = window.location.href.includes("products/");

      // Keep the alternate template (e.g. main-product-v2) when re-rendering
      // the section — without it the Section Rendering API falls back to the
      // default product template and template-gated blocks (texture banner)
      // drop out of the morphed HTML (CNV-2650).
      const templateView =
        this.$refs.productInfoElement.dataset.templateView ||
        new URLSearchParams(window.location.search).get("view") ||
        "";

      const params = new URLSearchParams();
      if (preselectedVariantId) params.set("variant", preselectedVariantId);
      if (templateView) params.set("view", templateView);
      params.set("sections", this.sectionId);

      let url = `/products/${productHandle}?${params.toString()}`;
      // const productUrl = `/products/${productHandle}.js`;

      if (!isProductPage) {
        url = `/products/${productHandle}?view=product`;
      }

      fetch(url)
        .then((response) => {
          if (!response.ok) {
            throw new Error("Network response was not ok");
          }
          return !isProductPage ? response.text() : response.json();
        })
        .then((response) => {
          if (!isProductPage) {
            const html = new DOMParser().parseFromString(response, 'text/html');
            const productSection  = html.querySelector(`[data-product-section-id]`);
            if (!productSection) {
              console.error("Product section not found");
              return;
            }
            document.querySelector(`#shopify-section-${this.sectionId}`).replaceWith(productSection.parentElement);
            return;
          }

          if (!response[this.sectionId]) {
            console.error("Product section not found");
            return;
          }

          morphSection(this.sectionId, response[this.sectionId]);

          if (window.location.href.includes("products/")) {
            // Keep ?view= in the address bar only if the visitor arrived with
            // one (preview/editor links) — live URLs with an assigned template
            // stay clean; the section fetch above always carries the view.
            const hadViewParam = new URLSearchParams(
              window.location.search
            ).has("view");
            const viewSearch =
              hadViewParam && templateView ? `?view=${templateView}` : "";
            window.history.pushState(
              { urlPath: productHandle },
              "",
              `${productHandle}${viewSearch}`
            );
          }
        })
        .catch((error) => {
          console.error("Error loading product:", error);
        });
    },

    reExecuteScript() {
      const scripts = document.querySelectorAll(".re-execute-scripts");
      scripts.forEach((script) => {
        // console.log(script);  // Log the script content
        const newScript = document.createElement("script");
        const src = newScript.getAttribute("src")
          ? newScript.getAttribute("src")
          : "";
        if (src != "") {
          newScript.setAttribute("src", src);
        } else {
          newScript.text = script.text;
        }
        // Append the script to the container
        this.$refs.productInfoElement.appendChild(newScript);
        // Remove the script immediately after execution
      });
    },
  }));
});
